import UploadFileIcon from '@mui/icons-material/UploadFile';

import { roleManager } from '@/router/consts';

import { 월별_결제_내역_다운로드_라우터 } from '.';
import type { SidebarMenu } from '../types';

// 카페24 마스터 계정 전용 페이지 메뉴
const Cafe24MasterMenus: SidebarMenu[] = [
  {
    title: 월별_결제_내역_다운로드_라우터.cafe24.handle.title,
    path: 월별_결제_내역_다운로드_라우터.cafe24.path,
    icon: <UploadFileIcon />,
    roles: [roleManager],
  },
];

export default Cafe24MasterMenus;
